import { render, staticRenderFns } from "./ContactDistributionsByChannel.vue?vue&type=template&id=0a0ad86e&scoped=true"
import script from "./ContactDistributionsByChannel.vue?vue&type=script&lang=js"
export * from "./ContactDistributionsByChannel.vue?vue&type=script&lang=js"
import style0 from "./ContactDistributionsByChannel.vue?vue&type=style&index=0&id=0a0ad86e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0ad86e",
  null
  
)

export default component.exports